/*
|---------------------------------------------------------------------
| Board Vuex State
|---------------------------------------------------------------------
|
| Kanban board initial cards state from content demo
|
*/
export default {
    // NOTAS COBRO
    notas_cobro: null,
    notas_cobro_selected: null,
    factura: {
        id_dte: 0,
        nota_credito: null,
        // Factura de referencia (fila de "facturas emitidas") sobre la que se
        // emite la nota de crédito. Necesaria para re-emitir y para vincular la
        // NC / nueva factura a la nota de cobro en el portal-api.
        factura_original: null,
        // Motivo elegido al emitir la NC: 'anular' | 'texto' | 'monto'. La NC
        // SIEMPRE anula (CodRef 1); el motivo define qué se ofrece DESPUÉS:
        // 'anular' finaliza; 'texto'/'monto' habilitan refacturar en ese modo.
        motivo_nc: null
    }

}
